import React from "react";
import AirtimePin from "../../Component/Products/AirtimePin";

const MainAirtimePin = () => {
	return <AirtimePin />;
};

export default MainAirtimePin;
